// extracted by mini-css-extract-plugin
export default {"label":"DropdownSelector-module__label___Z6FKO"};